export enum UrlConnectionEnum {
  LOGIN = 'v1/chiesi/user/login',

  SIGN_UP = 'v1/achiesi/user/register',

  // Token
  GET_TOKEN = 'v1/chiesi/send/token',

  // DOCTORS
  GET_DOCTORS = 'v1/adm/chiesi/doctors',
  GET_DOCTOR_DETAILS = 'v1/adm/chiesi/doctor/detalhes',
  UPDATE_DOCTOR = 'v1/adm/chiesi/doctor/editar',

  //Dashboard
  GET_DASHBOARD = 'v1/adm/chiesi/dashboard',
  GET_DASHBOARD_ACCUMULATED = 'v1/adm/chiesi/dashboard/acumulado',

  GET_LIST_KIT = 'v1/adm/chiesi/kits/lista',
  UPDATE_KIT = 'v1/chiesi/kit/editar',
  CREATE_KIT = 'v1/chiesi/kit/inserir',

  GET_RESCUE_LIST = 'v1/adm/chiesi/resgate/lista',
  GET_RESCUE_STATUS = 'v1/adm/chiesi/resgate/status',
  UPDATE_RESCUE = 'v1/adm/chiesi/resgate/editar',

  GET_RESCUES_CSV_REPORT = 'v1/adm/chiesi/relatorio/csv',
  GET_DOCTORS_CSV_REPORT = 'v1/adm/chiesi/doctors/relatorio/csv',

  // COMUNICAÇÃO E DISPAROS
  // Comunicação real nos ambientes habilitados.
  GET_EMAIL_TEMPLATES = 'v1/adm/chiesi/comunicacao/templates',
  CREATE_EMAIL_TEMPLATE = 'v1/adm/chiesi/comunicacao/templates',
  SEND_DISPATCH_OCCASIONAL = 'v1/adm/chiesi/comunicacao/disparo/pontual',
  SEND_DISPATCH_MASSIVE = 'v1/adm/chiesi/comunicacao/disparo/massivo',
  GET_COMMUNICATION_HISTORY = 'v1/adm/chiesi/comunicacao/historico',
  GET_COMMUNICATION_HISTORY_DETAILS = 'v1/adm/chiesi/comunicacao/historico/detalhes',

  // ALERTAS DE TERMOS
  GET_CONSENT_ALERTS = 'v1/adm/chiesi/consentimento/alertas',
  UPDATE_CONSENT_ALERTS = 'v1/adm/chiesi/consentimento/alertas',
  PREVIEW_CONSENT_ALERTS = 'v1/adm/chiesi/consentimento/alertas/simular',
  RUN_CONSENT_ALERTS = 'v1/adm/chiesi/consentimento/alertas/executar',
  RESOLVE_CONSENT_ALERT = 'v1/adm/chiesi/consentimento/alertas/resolver',
}
